import styled from 'styled-components';
import { Typography } from 'antd';

const { Text } = Typography;

export const Card = styled.div<{ $hoverBg: string }>`
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 2px;

    max-width: 182px;
    min-width: 182px;

    padding: 16px 24px;
    border-radius: 8px;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.03),
        0 1px 6px -1px rgba(0, 0, 0, 0.02), 0 2px 4px 0 rgba(0, 0, 0, 0.02);

    transition: background 0.3s ease, transform 0.2s ease, box-shadow 0.2s ease;

    &:hover {
        cursor: pointer;
        background: ${props => props.$hoverBg};
        transform: scale(1.02);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }

    svg {
        transition: transform 0.3s ease;
    }

    &:hover svg {
        transform: rotate(5deg) scale(1.1);
    }
`;

export const Title = styled(Text)<{ $color: string }>`
    font-size: 12px;
    text-align: center;
    color: ${props => props.$color};
`;
